// ContactUs.js
import React, { useState } from 'react';
import emailjs from 'emailjs-com'; // ✅ Added EmailJS
import './contactus.css';

function ContactUs() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // EmailJS service
    const serviceID = 'service_3ll0pai';     // Replace with your EmailJS service ID
    const templateID = 'template_hmunn5x';   // Replace with your EmailJS template ID
    const userID = '4qRMFMVMforJccgUz';        // Replace with your EmailJS public key

    emailjs.send(serviceID, templateID, formData, userID)
      .then((response) => {
        console.log('Email successfully sent!', response.status, response.text);
        setIsSubmitting(false);
        setIsSubmitted(true);

        // Reset form
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          message: ''
        });

        // Hide success message after 5 seconds
        setTimeout(() => {
          setIsSubmitted(false);
        }, 5000);
      })
      .catch((error) => {
        console.error('Failed to send email:', error);
        setIsSubmitting(false);
        alert('Oops! Something went wrong. Please try again.');
      });
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        {/* Left Column - Info & Map */}
        <div className="contact-info">
          <div className="info-header">
            <h1>Get in Touch</h1>
            <p className="subtitle">
              We're here to help and answer any questions you might have about our eye care services.
            </p>
          </div>

          <div className="details-grid">
            {/* Phone Card */}
            <div className="detail-card">
              <div className="card-icon">📞</div>
              <div className="card-content">
                <h3>Call us directly</h3>
                <div className="value phone">+94 77 344 0937</div>
                <div style={{ color: '#9bb5d4', fontSize: '0.85rem', marginTop: '0.3rem' }}>
                  Available Mon-Fri, 9am-6pm
                </div>
              </div>
            </div>

            {/* Address Card */}
            <div className="detail-card">
              <div className="card-icon">📍</div>
              <div className="card-content">
                <h3>Visit our headquarters</h3>
                <div className="value">
                  932, Galle Road,<br />
                  Colombo 03,<br />
                  Sri Lanka
                </div>
              </div>
            </div>

            {/* Email Card */}
            <div className="detail-card">
              <div className="card-icon">✉️</div>
              <div className="card-content">
                <h3>Email us</h3>
                <div className="value">contact@colomboeyecare.lk</div>
                <div style={{ color: '#9bb5d4', fontSize: '0.85rem', marginTop: '0.3rem' }}>
                  We reply within 24 hours
                </div>
              </div>
            </div>
          </div>

          {/* Map Preview */}
          <div className="map-preview">
            <div className="map-placeholder">
              <span className="map-icon">🗺️</span>
              <div className="map-text">
                <strong>Find us on map</strong>
                <div style={{ fontSize: '0.9rem', marginTop: '0.2rem' }}>
                  932, Maradana Road, Colombo 08
                </div>
                <a 
                  href="https://maps.google.com/?q=932+Galle+Road+Colombo+03+Sri+Lanka" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="directions"
                >
                  Get Directions →
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Contact Form */}
        <div className="contact-form-container">
          <div className="form-header">
            <h2>Send us a message</h2>
            <p>We'll get back to you as soon as possible</p>
          </div>

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">First Name *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="John"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">Last Name *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Doe"
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="john.doe@example.com"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+94 77 123 4567"
                />
              </div>
              
            </div>

            <div className="form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Tell us about your inquiry..."
                required
              />
            </div>

            <button 
              type="submit" 
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : <>Send Message <span className="btn-icon">→</span></>}
            </button>

            {isSubmitted && (
              <div className="success-message">
                ✓ Thank you for contacting us! We'll respond shortly.
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;